import { render, staticRenderFns } from "./Lookups.vue?vue&type=template&id=706a7a9b&scoped=true"
import script from "./Lookups.vue?vue&type=script&lang=ts"
export * from "./Lookups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706a7a9b",
  null
  
)

export default component.exports